/* Document intake vocabulary shared by DocumentsPage / DocumentDetailPage.
 *
 * Validator reason codes → officer words (Gap 7, Ale ruling 2026-07-22:
 * an encrypted cause must be distinguishable from other failures — the
 * fix differs: remove the password vs re-scan/replace the file). Codes
 * come from intake/validator.py ValidationResult.reason, persisted on
 * ``documents.intake_failure_reason`` and served as ``failure_reason``.
 */

const FAILURE_LABEL: Record<string, string> = {
  encrypted: 'password-protected',
  corrupt: 'unreadable file',
  zero_byte: 'empty file',
  wrong_mime: 'not a PDF',
  oversized: 'too large',
}

export function failureLabel(reason: string): string {
  return FAILURE_LABEL[reason] ?? reason.replace(/_/g, ' ')
}
